

class CustomSwiper extends HTMLElement {
    constructor() {
        super(),
        this.slidesPerView_pc = Number(this.getAttribute("data-row-pc")) || 3,
        this.slidesPerView_m = Number(this.getAttribute("data-row-m")) || 2,
        this.has_button = this.getAttribute("data-button") == "true",
        this.has_pagination = this.getAttribute("data-pagination") == "true"
        this.loop = this.getAttribute("data-loop") == "true"
     
    }
    connectedCallback() {
        setTimeout( () => this.initSwiper(), 0)
    }
    initSwiper() {
        const nextEl = this.querySelector(".swiper-button-next")
          , prevEl = this.querySelector(".swiper-button-prev")
          , pagination = this.querySelector(".swiper-pagination")
          , swiperContainer = this.querySelector(".custom-swiper-container") || this
          , config = {
            slidesPerView: this.slidesPerView_m,
            spaceBetween: 10,
            loop:this.loop,
            breakpoints: {
                700: {
                    slidesPerView: this.slidesPerView_pc,
                    spaceBetween: 20
                }
            }
        };
        this.has_button && nextEl && prevEl && (config.navigation = {
            nextEl,
            prevEl
        }),
        this.has_pagination && pagination && (config.pagination = {
            el: pagination
        }),

        new Swiper(swiperContainer,config)

    }
   
}
customElements.define("custom-swiper", CustomSwiper);